import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { SettingsService } from './settings.service';
import { HttpHelper } from '../helpers/http-helper';
import { StorageManagerService } from './storage-manager.service';
import { AuthenticationService } from './authentication.service';
import { Observable, catchError, map, throwError } from 'rxjs';
import { IApiResult } from '../models/api-result';
import { RTCDPragmaticValidation } from '../models/rtcd_pragmatic_validation.model';

@Injectable()
export class PragmaticValidationService {
  httpHelper: HttpHelper;

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService,
    private authService: AuthenticationService,
    private storageManagerService: StorageManagerService,
  ) {
    this.httpHelper = new HttpHelper(http, authService, storageManagerService);
  }

  pragmaticValidation(data: RTCDPragmaticValidation) {
    const headers = this.httpHelper.createHttpHeaders();
    const settings = this.settingsService.getSettings();
    const apiUrl = settings.ApiGatewayUrl;
    const action = `ssdpds/v1/Pragmatic/Validate`;
    return this.http.post(`${apiUrl}/${action}`, data, { headers: headers })
      .pipe(map(this.extractData),
        map(p => p.data),
        catchError(this.handleErrors));
  }

  downloadFile(fileName: string, filePath: string) {
    const headers = this.httpHelper.createHttpHeaders();
    const settings = this.settingsService.getSettings();
    const apiUrl = settings.ApiGatewayUrl;
    const action = `ssdpds/v1/Pragmatic/DownloadFile?filePath=${filePath}&fileName=${fileName}`;
    return this.http.post(`${apiUrl}/${action}`, { headers: headers, responseType: 'blob' })
      .pipe(map(response => response),
        catchError(this.handleErrors));
  }

  private extractData(response: any) {
    if (response.status < 200 || response.status >= 300) {
      throw new Error('Bad response status: ' + response.status);
    }
    const body = response as IApiResult;
    return body;
  }

  // Error handling
  private handleErrors(error: any): Observable<any> {
    const GENERIC_ERROR_MSG = 'It looks like something went wrong. Try reloading the page or contacting support if this issue continues.';
    const bDisplayDetailMsg = error && error.error && error.error.isBusinessErrorMessage
      ? true
      : !!isDevMode();
    error.error = error && error.error && error.error.message && bDisplayDetailMsg
      ? error.error.message
      : GENERIC_ERROR_MSG;

    return throwError(() => error.error);
  }

}
